module.exports = __webpack_public_path__ + "static/yeti-0f77d88d9e98f42a22f62482480db1d8.jpg";